// extracted by mini-css-extract-plugin
module.exports = {"search-result-item-title":"_3jTsqSoUdWKB8GMlpvumpr","search-result-item-subtitle":"_3mYT2HqbJyiJgk-6E_Ympd"};